<template>
  <div class="container">
    <Container :active_path="path" :plate="'项目巡览'">
      <div class="base-warp">
        <div class="head">
          <el-form :model="search" ref="form" label-width="80px" :inline="true" size="normal">
            <el-form-item label="名称">
              <el-input v-model="search.title" size="mini" placeholder="请输入企业服务名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="mini" @click="confirm">搜索</el-button>
              <el-button type="success" size="mini" @click="reset">重置</el-button>

              <el-button type="primary" size="mini" @click="addp">添加企业服务</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-dialog v-bind="$attrs" v-on="$listeners" :visible.sync="dialogVisible" title="企业服务" width="60%">
            <el-row :gutter="24">
              <el-form ref="elForm" :model="formData" :rules="rules" size="small" label-width="140px"
                label-position="left">
                <el-row :gutter="15">
                  <el-col :span="12">
                    <el-form-item label="服务名称" prop="title">
                      <el-input v-model="formData.title" placeholder="请输入服务名称" show-word-limit clearable
                        prefix-icon='el-icon-s-opportunity' :style="{ width: '100%' }"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="服务标签" prop="label">
                      <el-input v-model="formData.label" placeholder="请输入服务标签" show-word-limit clearable
                        prefix-icon='el-icon-s-opportunity' :style="{ width: '100%' }"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="15">
                  <el-col :span="12">
                    <el-form-item label="产品排序">
                      <el-input type="number" v-model="formData.listorder" placeholder="排序"></el-input>
                      <div>排序值 越小越靠前</div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="服务介绍" prop="info">
                      <el-input v-model="formData.info" placeholder="请输入服务介绍" show-word-limit clearable
                        prefix-icon='el-icon-s-opportunity' :style="{ width: '100%' }"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="15">
                  <el-col :span="12">
                    <el-form-item label="企业服务电话" prop="phone">
                      <el-input v-model="formData.phone" placeholder="请输入服务电话" show-word-limit clearable
                        prefix-icon='el-icon-s-opportunity' :style="{ width: '100%' }"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="企业服务地址" prop="address">
                      <el-input v-model="formData.address" placeholder="请输入企业地址" show-word-limit clearable
                        prefix-icon='el-icon-s-opportunity' :style="{ width: '100%' }"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="24">
                    <el-form-item label="企业服务介绍">
                      <tin-editor :value="formData.content" class="tin-editor" @input="getcontent"></tin-editor>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="15">

                  <el-col :span="12">
                    <el-form-item label="企业服务详情图">
                      <el-upload class="upload-demo" drag action="/api/Upload/uploadfilevsnologo/"
                        :on-success="handleUploadSuccessbigimg" :before-upload="beforeUploadbigimg" multiple :limit="1">
                        <i class="el-icon-upload"></i>

                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过1M</div>

                      </el-upload>
                    </el-form-item>
                    <div v-if="imageUrlbigimg" style="text-align: center;" class="el-upload__text">图片如下</em></div>

                    <img v-if="imageUrlbigimg" :src="imageUrlbigimg" class="avatar" style="text-align: center;">
                  </el-col>
                  <el-col :span="12">

                    <el-form-item label="企业服务头像">
                      <el-upload class="upload-demo" drag action="/api/Upload/uploadfilevsnologo/"
                        :on-success="handleUploadSuccess" :before-upload="beforeUpload" multiple :limit="1">
                        <i class="el-icon-upload"></i>

                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过1M</div>

                      </el-upload>
                    </el-form-item>
                    <div v-if="imageUrl" style="text-align: center;" class="el-upload__text">图片如下</em></div>

                    <img v-if="imageUrl" :src="imageUrl" class="avatar" style="text-align: center;">
                  </el-col>
                  <el-col :span="24">
                  <el-form-item label="产品图片列表"
                                prop="">
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadfilevsnologo/"
                               :on-success="phandleUploadSuccess"
                               :before-upload="beforeUpload"
                               :file-list="fileList"
                               :on-remove="handleRemove"
                               multiple
                               :limit="10"
                               list-type="picture">
                      <i class="el-icon-upload"></i>

                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                      <div class="el-upload__tip"
                           slot="tip">只能上传jpg/png文件，且不超过2M,最多10张</div>

                    </el-upload>
                  </el-form-item>
                </el-col>
                </el-row>

              </el-form>
            </el-row>

            <div slot="footer">
              <el-button @click="close">取消</el-button>
              <el-button type="primary" @click="handleConfirm">确定</el-button>
            </div>
          </el-dialog>
        </div>
        <div class="table-box">
          <el-table :data="tabledata" border size="mini"
            :header-cell-style="{ background: '#f7f7f7', color: '#999', textAlign: 'center', fontWeight: 'normal' }">
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="title" label="企业名称" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="label" label="企业标签" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="phone" label="企业电话" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="address" label="企业地址" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="listorder" label="企业排序" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="pics" label="企业头像" show-overflow-tooltip align="center">
              <template slot-scope="s">
                <el-image style="width: 100px; height: 50px; margin-bottom:-4px;" :src="s.row.img" />
              </template>
            </el-table-column>
            <el-table-column prop="index" label="操作" width="210">
              <template slot-scope="s">
                <el-button type="warning" v-if="s.row.putaway" size="mini" @click="putaway(s.row)">下架</el-button>
                <el-button type="success" v-if="!s.row.putaway" size="mini" @click="putaway(s.row)">上架</el-button>
                <el-button type="danger" size="mini" @click="del(s.row)">删除</el-button>
                <el-button type="primary" size="mini" @click="edit(s.row)" plain>编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination class="page-tion" @current-change="currentChange" layout="prev, pager, next" :page-size="pagesize"
          :total="total" background>
        </el-pagination>
      </div>
    </Container>
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
import Container from "../../../components/container";
import TinEditor from '../../../components/tin-editor.vue'  // 富文本

export default {
  components: {
    Container, TinEditor
  },
  data () {
    return {
      path: '/reallyWillBuy/enterprise',
      search: {
        title: '',
      },
      dialogVisible: false,
      pageNo: 1,
      pagesize: 14,
      formData: {
        title: '',//企业名称
        img: '', //企业头像
        bigimg: '',//详情图片
        label: '', //企业标签
        info: '',//企业简介
        content: '',//企业介绍
        phone: '',//电话号
        address: '',//地址
        listorder: '',//企业排序
        id: '',
        photos:[]
      },
      rules: {
        title: [{
          required: true,
          message: '请输入该企业名称',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入该企业电话',
          trigger: 'blur'
        }], address: [{
          required: true,
          message: '请输入该企业地址',
          trigger: 'blur'
        }], info: [{
          required: true,
          message: '请输入该企业介绍',
          trigger: 'blur'
        }], label: [{
          required: true,
          message: '请输入该企业标签',
          trigger: 'blur'
        }],
      },
      tabledata: [],
      total: 0,
      imageUrl: '',
      imageUrlbigimg: '',
      fileList: [],


    }
  },
  mounted () {
    this.getTableData();
  },
  methods: {
    handleRemove(file, fileList) {
      this.formData.photos.splice(this.formData.photos.index, 1)
      },
       // photos上传成功后
       phandleUploadSuccess (response, file, fileList) {
      const that =this
      that.formData.photos.push(response.data)

    },
    beforeUpload (file) {
      // let isRightSize = file.size / 1024 / 1024 < 1
      // if (!isRightSize) {
      //   this.$message.error('文件大小超过 1MB')
      // }
      let isAccept = new RegExp('image/*').test(file.type)
      if (!isAccept) {
        this.$message.error('应该选择image/*类型的文件')
      }
      return isAccept
    },
    getcontent (content) {
      this.formData.content = content;
    },
    addp () {
      this.dialogVisible = true
      this.formData = {}
      this.imageUrl = ''
      this.imageUrlbigimg = ''
      this.fileList = []
      this.formData.photos = []
      
    },
    edit (row) {
      // console.log(row);
      this.fileList = []
      this.formData.photos = []

      this.dialogVisible = true
      this.formData = row
      this.imageUrl = row.img
      this.imageUrlbigimg = row.bigimg
      const img = row.photos

      for (var i = 0; i < img.length; i++) {
        var obj = {
          name: '',
          url: img[i]
        }
        this.fileList.push(obj)
      }
      // console.log(this.fileList);
    },
    close () {

      this.dialogVisible = false
    },
    handleConfirm () {
      this.$refs['elForm'].validate(valid => {
        if (valid) {
          // console.log(this.formData, '8888');
          var params = {
            id: this.formData.id,
            label: this.formData.label,
            title: this.formData.title,
            img: this.formData.img,
            bigimg: this.formData.bigimg,
            info:this.formData.info,
            listorder: this.formData.listorder,
            content: this.formData.content,
            phone: this.formData.phone,
            address: this.formData.address,
            photos: this.formData.photos

          }

          this.$api.addenterpriseServices(params).then(res => {
            // console.log(res, '=====');
            if (res === '添加成功' || res === '修改成功') {
              this.$message.success(res);
              this.dialogVisible = false
            }
            this.getTableData();
            this.formData = {}
            this.imageUrl = ''

          })
        } else {
          this.$message.error('提交失败');
          this.dialogVisible = false
          return false;
        }
      })
    },
    beforeUpload (file) {
      let isRightSize = file.size / 1024 / 1024 < 1
      if (!isRightSize) {
        this.$message.error('文件大小超过 1MB')
      }
      let isAccept = new RegExp('image/*').test(file.type)
      if (!isAccept) {
        this.$message.error('应该选择image/*类型的文件')
      }
      return isRightSize && isAccept
    },
    // 文件上传成功时的钩子
    handleUploadSuccess (item, response) {
      let { data, errCode, msg } = response;
      // console.log(data, 'data');
      // console.log(item, 'item');

      if (item.msg === '上传成功') {
        this.$message.success('上传成功');
        this.formData.img = item.data
        this.imageUrl = item.data

        this.$forceUpdate()
      } else {
        this.$message.error('上传失败');
      }
    },
    beforeUploadbigimg (file) {
      let isRightSize = file.size / 1024 / 1024 < 1
      if (!isRightSize) {
        this.$message.error('文件大小超过 1MB')
      }
      let isAccept = new RegExp('image/*').test(file.type)
      if (!isAccept) {
        this.$message.error('应该选择image/*类型的文件')
      }
      return isRightSize && isAccept
    },
    // 文件上传成功时的钩子
    handleUploadSuccessbigimg (item, response) {
      let { data, errCode, msg } = response;
      // console.log(data, 'data');
      // console.log(item, 'item');

      if (item.msg === '上传成功') {
        this.$message.success('上传成功');
        this.formData.bigimg = item.data
        this.imageUrlbigimg = item.data

        this.$forceUpdate()
      } else {
        this.$message.error('上传失败');
      }
    },
    confirm () {
      this.pageNo = 1;
      this.getTableData();
    },
    currentChange (page) {
      this.pageNo = page;
      this.getTableData();
    },
    //上下架
    putaway (row) {
      var params = {
        id: row.id,
        putaway: !row.putaway
      };
      this.$api.putenterpriseServices(params).then((data) => {
        this.$message.success(data);
        this.getTableData();
      });
    },
    del (row) {
      this.$confirm("是否确定删除" + row.title).then(
        (confirm) => {
          var params = {
            id: row.id
          };
          this.$api.delenterpriseServices(params).then((data) => {
            this.$message.success(data);
            this.getTableData();
          });
        },
        (cancel) => { }
      );
    },
    getTableData () {
      var params = {
        title: this.search.title,
        pageNo: this.pageNo,
        pagesize:this.pagesize
      }
      this.$api.getenterpriseServices(params).then(data => {
        // console.log(data, '---');
        this.tabledata = data.list;
        this.total = data.total;
      })
    },
    reset () {
      this.search.title = ''
      this.getTableData()
    },

  },
}
</script>

<style lang="scss" scoped>
.el-rate {
  display: inline-block;
  vertical-align: text-top;
}

.el-upload__tip {
  line-height: 1.2;
}

.right-edit-box {
  position: absolute;
  right: 0;
  top: 0;
}

.el-carousel__item {
  background: #fff;
  border: 1px dashed #999;

  .img {
    width: 270px;
    height: 202px;
    vertical-align: middle;
    position: relative;
  }

  .name {
    position: absolute;
    color: #fff;
    padding: 0 6px;
    background: rgba(0, 0, 0, 0.4);
    bottom: 4px;
    left: 4px;
  }
}

.left-row {
  border: 1px dashed #d9d9d9
}

.avatar {
  // margin-left: 40px;
  width: 250px;
  height: 180px;
  display: block;
  margin: 0 auto;
}

.tin-editor {
  width: 100%;
}
</style>